import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Buefy from "buefy";
import VueGtag from "vue-gtag";
import "@/assets/fonts/Geomanist-Regular-Webfont/stylesheet.css";
import "@/assets/custom.scss";

Vue.use(Buefy);
Vue.use(VueGtag, {
  config: { id: "UA-87673204-2" }
});
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
